import React from 'react';
import { IItemRestaurantDevice } from 'types';
import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import style from './AssignCheckbox.module.scss';

interface IAssignedCheckbox {
	data: IItemRestaurantDevice;
	toggleDeviceAssignedStatus: (deviseId: string, status: boolean) => void;
}

const AssignCheckbox: React.FC<IAssignedCheckbox> = ({ data, toggleDeviceAssignedStatus }) => {
	const handleChange = (e: CheckboxChangeEvent) => {
		toggleDeviceAssignedStatus(data.id, e.target.checked);
	};

	return <Checkbox className={style.checkBoxElement} onChange={handleChange} checked={data.isAssigned} />;
};

export default React.memo(AssignCheckbox);
